/**
 * The two cards on the role selection screen are the same surface with different actions, so the
 * card itself carries no role-specific knowledge — only the heading and whatever is stacked below.
 */
export default function RoleCard({
  children,
  testId,
  title,
}: {
  children: React.ReactNode
  testId?: string
  title: string
}): React.ReactElement {
  return (
    <section
      className="flex flex-col items-center gap-4 p-6 bg-white border-1.5 border-school-line rounded-3xl sm:p-10"
      data-test-id={testId}
    >
      <h2 className="text-5 font-bold text-school-ink sm:text-2xl">{title}</h2>
      {children}
    </section>
  )
}
